import { factory, sequence } from 'stahlwerk';

export const createTemplate = factory({
  id: sequence(),
  name: 'Template name',
  description: 'Some description',
  createdAt: new Date(),
});
